import { computed, inject, provide } from "vue";
const LocalConfigKey = "VaLocalConfig";
const CONFIGS_DEFAULT = computed(() => []);
function useLocalConfig() {
  return inject(LocalConfigKey, CONFIGS_DEFAULT);
}
function provideLocalConfig(config) {
  provide(LocalConfigKey, config);
}
function useLocalConfigProvider(config) {
  const prevChain = useLocalConfig();
  const nextChain = computed(() => [...prevChain.value, config.value]);
  provideLocalConfig(nextChain);
}
export {
  useLocalConfigProvider as a,
  provideLocalConfig as p,
  useLocalConfig as u
};
//# sourceMappingURL=useLocalConfig.js.map
